import { useIsMobile } from '@/common/hooks/useIsMobile';
import BannerDesktop from '@/entities/HomePage/Banner/desktop';
import BannerMobile from '@/entities/HomePage/Banner/mobile';

const Banner = () => {
  const isMobile = useIsMobile();
  return (
    <>
      {isMobile && <BannerMobile />}
      {!isMobile && <BannerDesktop />}
    </>
  );
};

export default Banner;
